<script>
/**
 * 区块标题（kicker + h2 + 可选描述）
 */
export default {
  name: 'NhSectionHead',
  props: {
    kicker: { type: String, default: '' },
    title: { type: String, default: '' },
    desc: { type: String, default: '' }
  }
}
</script>

<template>
  <div v-reveal class="section-head">
    <span v-if="kicker" class="kicker">{{ kicker }}</span>
    <h2>{{ title }}</h2>
    <p v-if="desc">{{ desc }}</p>
  </div>
</template>
